import { Box, Typography, Chip, Paper, Stack } from '@mui/material'
import GoogleIcon from '../../../../components/icon/GoogleIcon'
import ClientHeaderCard from './ClientHeaderCard'
import { formatMoney } from '../../../../helpers/utils'
import { faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  CLIENT_HEADER_COLORS,
  CLIENT_HEADER_LAYOUT,
  CLIENT_STATUS
} from '../../constants/ClientDashboardConst'

export default function ClientHeader({ clientData }) {
  return (
    <Paper elevation={3} sx={{ p: 2, borderRadius: 2, mb: 3 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'stretch',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Stack direction="row" spacing={1} alignItems="center" mb={1}>
            <Typography fontWeight={700} fontSize={18} sx={{ color: CLIENT_HEADER_COLORS.title }}>
              {clientData.customer_name_db_ref || '-'}
            </Typography>

            {clientData.active && (
              <Chip
                label={CLIENT_STATUS.active.label}
                size="small"
                className={CLIENT_STATUS.active.className}
              />
            )}

            {!clientData.active && (
              <Chip
                label={CLIENT_STATUS.inactive.label}
                size="small"
                className={CLIENT_STATUS.inactive.className}
              />
            )}

            {clientData.has_balance_due && (
              <Chip
                label={CLIENT_STATUS.delinquent.label}
                size="small"
                className={CLIENT_STATUS.delinquent.className}
              />
            )}
          </Stack>

          <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
            <ClientHeaderCard
              icon={
                <GoogleIcon
                  name="barcode_scanner"
                  filled
                  size={18}
                  color={CLIENT_HEADER_COLORS.label}
                />
              }
              value={clientData.db_ref}
            />

            <ClientHeaderCard
              icon={
                <GoogleIcon
                  name="finance_chip"
                  filled
                  size={18}
                  color={CLIENT_HEADER_COLORS.label}
                />
              }
              value={clientData.is_cash_client ? 'Contado' : 'Crédito'}
            />

            <ClientHeaderCard
              icon={
                <FontAwesomeIcon
                  icon={faHandHoldingUsd}
                  style={{ color: `${CLIENT_HEADER_COLORS.label}` }}
                />
              }
              value={clientData.price_list_name || '-'}
              maxWidth={CLIENT_HEADER_LAYOUT.metaMaxWidth}
            />

            <ClientHeaderCard
              icon={
                <GoogleIcon
                  name="account_box"
                  filled
                  size={18}
                  color={CLIENT_HEADER_COLORS.label}
                />
              }
              value={`Segmento: ${[
                clientData.qualifier_2,
                clientData.qualifier_3,
                clientData.qualifier_4,
                clientData.qualifier_5,
                clientData.qualifier_6,
                clientData.qualifier_7
              ]
                .filter((qualifier) => qualifier != null && qualifier !== '')
                .join(', ')}`}
              maxWidth={CLIENT_HEADER_LAYOUT.metaMaxWidth}
            />

            <ClientHeaderCard
              icon={
                <GoogleIcon name="distance" filled size={18} color={CLIENT_HEADER_COLORS.label} />
              }
              value={clientData.location_description || '-'}
              maxWidth={CLIENT_HEADER_LAYOUT.metaMaxWidth}
            />
          </Stack>
        </Box>

        <Box
          sx={{
            minWidth: CLIENT_HEADER_LAYOUT.creditMinWidth,
            alignSelf: { xs: 'flex-end', sm: 'center' },
            textAlign: 'right',
            mt: { xs: 2, sm: 0 }
          }}
        >
          <Typography fontSize={13} fontWeight={600} color={CLIENT_HEADER_COLORS.muted}>
            MONTO DISPONIBLE DE CRÉDITO
          </Typography>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'baseline',
              gap: 1,
              mt: 0.5,
              whiteSpace: 'nowrap'
            }}
          >
            {clientData.is_cash_client ? (
              <Typography fontSize={24} fontWeight={800} color={CLIENT_HEADER_COLORS.creditMain}>
                {'-'}
              </Typography>
            ) : (
              <>
                <Typography fontSize={24} fontWeight={800} color={CLIENT_HEADER_COLORS.creditMain}>
                  {clientData.credit_balance != null ? formatMoney(clientData.credit_balance) : '-'}
                </Typography>

                <Typography
                  fontSize={16}
                  fontWeight={600}
                  color={CLIENT_HEADER_COLORS.creditSecondary}
                >
                  / {clientData.credit_limit != null ? formatMoney(clientData.credit_limit) : '-'}
                </Typography>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Paper>
  )
}
